export default __webpack_public_path__ + "images/e5b79b019b493d2668270d6cea0e2eb7.png";